import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  getTranslatedText,
  InlineMultiTextField,
  reactSelectInlineError,
  withErrorBoundary
} from '@nile/components';
import { cloneDeep, isEqual } from 'lodash';
import { validate } from 'validate.js';
import { emailValidator } from '@nile/components/src/Validators/fields';

const Label = styled.span`
  color: #000000;
  opacity: 0.6;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

const CC = styled.div`
  font-weight: 500;
  color: #000000;
  opacity: 0.6;
  margin-right: 12px;
  cursor: pointer;
  text-transform: capitalize;
`;

const CreateEmail = withErrorBoundary(
  injectIntl((props) => {
    const {
      intl,
      mailList = [],
      label,
      placeholder,
      updateChange,
      hidelabel,
      fontSize,
      error
    } = props;
    const [errorMap, setErrorMap] = useState(error || null);

    const validateEmail = (val) => {
      const data = { email: val };
      validate.validators.email.message = getTranslatedText(
        intl,
        'common.validatejs.email.invalid.message'
      );
      const emailError = validate(data, {
        email: emailValidator({
          mandatory: true
        })
      });
      if (emailError) {
        setErrorMap(emailError?.email[0]);
        return false;
      }
      setErrorMap(null);
      return true;
    };

    const itemAddHandler = (val) => {
      const data = { email: val };
      const clonedMailList = cloneDeep(mailList || []);
      clonedMailList.push(data);
      updateChange(clonedMailList);
    };

    const itemRemoveHandler = (val) => {
      const filteredMailList = [...mailList].filter(
        (mail) => mail.email !== val
      );
      updateChange(filteredMailList);
    };

    let data = [];
    if (mailList && mailList.length) {
      data = mailList?.reduce((res, val) => {
        return [...res, val?.email];
      }, []);
    }

    useEffect(() => {
      if (!isEqual(error, errorMap)) {
        setErrorMap(error);
      }
    }, [error]);

    return (
      <div className="grid full-width">
        <div className="fx fg1">
          {!hidelabel && (
            <Label className="mt-5 mr-10">
              <FormattedMessage id={label} />
            </Label>
          )}
          <InlineMultiTextField
            showAvatar
            name="item-input"
            label={label}
            values={data || []}
            placeholder={placeholder}
            onItemAdded={itemAddHandler}
            onItemDeleted={itemRemoveHandler}
            itemBackground="#f2f5ff"
            handleValidation={validateEmail}
            charCodes={[32, 188, 13]}
            fontSize={fontSize}
            showBorder={props.showBorder}
          />
        </div>
        <div>{errorMap && reactSelectInlineError(errorMap)}</div>
      </div>
    );
  })
);

function HiddenAction({ id, updateState, showField }) {
  const [visible, setVisible] = useState(false);
  const handleChange = () => {
    setVisible(true);
    updateState(id);
  };
  useEffect(() => {
    if (showField) {
      handleChange();
    } else {
      setVisible(false);
    }
  }, [showField]);
  return (
    !visible && (
      <CC onClick={handleChange}>
        <FormattedMessage id={id} />
      </CC>
    )
  );
}

export { CreateEmail, HiddenAction };
